import { useContext } from 'react';
import TopBanner from '../banner/TopBanner';
import PillButton from '../shared/button/PillButton';
import invokeDesktopFunction from '../../utils/desktop/invokeDesktopFunction';
import { desktopFuncNames } from '../../constants/desktop';
import cssVars from '../../styles/variables';
import {
  DESKTOP_UPDATE_BANNER_MESSAGE,
  DESKTOP_UPDATE_BANNER_BUTTON_LABEL,
} from '../../constants/localizations/desktop';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './installDesktopUpdateBanner.module.scss';

function handleBannerClick() {
  // quitDesktopAndInstallUpdate defined in gemini-desktop
  invokeDesktopFunction(desktopFuncNames.quitDesktopAndInstallUpdate);
}

export default function InstallDesktopUpdateBanner() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  return (
    <TopBanner className={css.topBanner}>
      <div className={css.messageWrapper}>
        <div className={css.updateIcon} />
        <div data-testid="updateMessage">
          {getLocalizedText(DESKTOP_UPDATE_BANNER_MESSAGE)}
        </div>
      </div>
      <PillButton
        id="installDesktopUpdateButton"
        className={css.installButton}
        onClick={handleBannerClick}
        label={getLocalizedText(DESKTOP_UPDATE_BANNER_BUTTON_LABEL)}
        backgroundColor={cssVars['--t-sharp']}
        textColor={cssVars['--ink-dark']}
      />
    </TopBanner>
  );
}
